import { render } from "./PerPageSelector.vue?vue&type=template&id=8d54eb74"
import script from "./PerPageSelector.vue?vue&type=script&lang=js"
export * from "./PerPageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__